import { Outlet, Navigate } from "react-router-dom"

const DevSpecRoutes = (props) => {
  return props.devSpecialist ? <Outlet /> : <Navigate to="/" />
}

export default DevSpecRoutes
